
import { defineComponent, ref, onMounted } from "vue";
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { useRoute } from "vue-router";
import { message } from "ant-design-vue";
import html2canvas from "html2canvas";
import routerName from "@/router/routerName";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "CarDataStatisticsDetail",
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const taskId = route.query && (route.query.id as string);
    const taskType = route.query && (route.query.taskType as string);
    const category_id = route.query && (route.query.category_id as string);
    const detail = ref();
    const getCarDetail = (id: string) => {
      Api.getcardatastatisticsdetails(id, category_id).then((val) => {
        if (val.err_no === ResultCodeType.success_200) {
          detail.value = val.result;
          console.log(detail.value);
        } else {
          message.error(val.err_msg);
        }
      });
    };
    const imageWrapper = ref(null) as any;
    // 截图
    const clickGeneratePicture = () => {
      html2canvas(imageWrapper.value, {
        logging: false,
        allowTaint: true,
        scale: window.devicePixelRatio,
        scrollY: 0,
        scrollX: 0,
        useCORS: true,
        backgroundColor: "#ffffff",
      }).then(function (canvas) {
        let imgUrl = canvas.toDataURL("image/png");
        var tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = imgUrl;
        tempLink.setAttribute("download", detail.value);
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        document.body.appendChild(tempLink);
        tempLink.download =
          detail.value.task_name +
          "____" +
          detail.value.start_time +
          "____" +
          detail.value.end_time; //文件命名
        tempLink.click(); // 启动下载
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(imgUrl);
      });
    };
    const timeConversion = (time: string) => {
      const times = Number(time);
      if (times < 60) {
        return times + t("minute");
      }
      return Math.floor(times / 60) + t("hour") + (times % 60) + t("minute");
    };
    onMounted(() => {
      getCarDetail(taskId);
    });
    return {
      detail,
      taskType,
      timeConversion,
      clickGeneratePicture,
      imageWrapper,
      routerName,
      t,
    };
  },
  components: {},
});
